import { FormOfferLocation } from './FormOfferLocation'

export default FormOfferLocation
